import axios from "axios";
import { BASE_URL } from "@funded-here-interface/common/src/constant/constant";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";

interface SubmitSkuPoOcrRequest {
  ids: number[];
  token: string;
  orgRoleId: number;
}

const deleteSkuPoOcr = async ({
  token,
  ids,
  orgRoleId,
}: SubmitSkuPoOcrRequest) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/sku-finance/loan-application/submit-sku-po-ocr`,
      { ids, orgRoleId },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      }
    );

    return response.data;
  } catch (e) {
    const message = getApiResponseErrorMsg(e);
    throw new Error(message);
  }
};
export default deleteSkuPoOcr;
